import "@Account/Styles/Main.less"

import BasePage from "@Account/Scripts/Pages/BasePage";

let App: any = {
    instances: {},
    pages: {},
    routes: {},
    resources: {}
};

App.pages.BasePage = BasePage;

(<any>window).App = App;